import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

const renderWidgetApp = (token, containerId = 'uu-container') => {
  const containerEl = document.getElementById(containerId);
  document.head.innerHTML += '<link rel="stylesheet" type="text/css" href="/static/main.css"></link>';

  if (containerEl) {
    ReactDOM.render(
      <React.StrictMode>
        <App token={token} />
      </React.StrictMode>,
      containerEl,
    );
  } else {
    console.log('No container found with id', containerId)
  }
};


const mode = process.env.REACT_APP_MODE;
console.log('App mode is', mode);
// if (mode === 'web' || !mode) {
  renderWidgetApp(null, 'uu-container');
// }

window.Uniteus = window.Uniteus || {};
window.Uniteus.assistanceRequestWidget = renderWidgetApp;

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
